import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../redux/hooks";
import { useEffect, useState } from "react";
import PATH from "../../../urls/path";
import { ReactComponent as LinkSvg } from "../../../assets/images/svg/link.svg";
import store from "../../../redux/store";
import Dialog from "../../../utils/component/dialog/dialog.index";
import Button from "../../../utils/component/button/button.index";
import { ButtonType } from "../button/button.interface";
import { DialogSize } from "../dialog/dialog.interface";
import { UserPlanStatus } from "../../../interfaces/general";
import { ENVIRONMENT } from "../../../environment";
import { shallowEqual } from "react-redux";

export default function WarningPlanDialog(): JSX.Element {
    const navigate = useNavigate();
    const { authStatus } = useAppSelector(({ auth: { authStatus } }) => ({ authStatus }), shallowEqual);
    const { newLogin } = useAppSelector(({ newLogin: { newLogin } }) => ({ newLogin }), shallowEqual);
    const [showPlanWarningModal, setShowPlanWarningModal] = useState<boolean>(false);

    useEffect(() => {
        if (
            authStatus === "VALID" &&
            !newLogin &&
            !sessionStorage.getItem("DANGER_PLAN_STATUS") &&
            store.getState().fileManager.activePurchases &&
            store.getState().fileManager.activePurchases.userPlanStatus === UserPlanStatus.DANGER
        )
            setShowPlanWarningModal(true);
    }, [store.getState().fileManager.activePurchases, newLogin]);

    return (
        <>
            {showPlanWarningModal && (
                <Dialog
                    size={DialogSize.MD}
                    status={showPlanWarningModal}
                    title={"هشدار سامانه"}
                    closeButton={true}
                    className="!px-4"
                    onClose={() => {
                        setShowPlanWarningModal(false);
                        sessionStorage.setItem("DANGER_PLAN_STATUS", String(true));
                    }}
                >
                    <div className="flex flex-col gap-12 py-8 px-4">
                        <div className="text-[14px] text-justify font-normal text-secondary-600">
                            {`کاربر عزیز، در حال حاضر زمان فضای ابری شما به اتمام رسیده است.`}
                            <br />
                            {`از اتمام زمان فضای ابری، شما می‌توانید به مدت یک ماه از تمامی امکانات ${ENVIRONMENT.brandName} استفاده نمایید. در این مدت لازم است نسبت به خرید فضای ابری جدید و یا حذف اطلاعات خود اقدام نمایید.`}
                            <br />
                            {`پس از یک ماه، دسترسی شما به امکانات سرویس محدود شده و فقط امکان مشاهده، دانلود و حذف اطلاعات را خواهید داشت. در این مدت لازم است نسبت به خرید فضای ابری جدید و یا حذف اطلاعات خود اقدام نمایید.`}
                            <br />
                            {`اگر در مدت ۲ ماه از زمان اتمام فضای ابری نسبت به خرید فضای ابری جدید اقدام ننمایید، دسترسی شما به اطلاعات ذخیره شده قطع و این اطلاعات به مدت ۶ ماه نگهداری می‌گردد. سپس دسترسی به آنها برای همیشه غیرممکن خواهد بود. در این مهلت ۶ماهه با خرید فضای ابری جدید می‌توانید علاوه بر بهره‌مندی کامل از امکانات سرویس، به اطلاعات قبلی خود نیز دسترسی داشته باشید.`}
                        </div>
                        <div className="flex lg:flex-row flex-col lg:gap-0 gap-4 lg:mb-0 mb-2 items-center justify-between">
                            <div className="flex items-center gap-8">
                                <div
                                    className="flex items-center gap-1 cursor-pointer"
                                    onClick={() => {
                                        setShowPlanWarningModal(false);
                                        sessionStorage.setItem("DANGER_PLAN_STATUS", String(true));
                                        navigate(PATH.planRecommendation);
                                    }}
                                >
                                    <div>
                                        <LinkSvg className="w-5 h-5" />
                                    </div>
                                    <div className="text-[14px] font-normal text-primary-600">خرید فضای ابری جدید</div>
                                </div>
                                <div
                                    className="flex items-center gap-1 cursor-pointer"
                                    onClick={() => {
                                        setShowPlanWarningModal(false);
                                        sessionStorage.setItem("DANGER_PLAN_STATUS", String(true));
                                        navigate(PATH.duplicatedFiles);
                                    }}
                                >
                                    <div>
                                        <LinkSvg className="w-5 h-5" />
                                    </div>
                                    <div className="text-[14px] font-normal text-primary-600">حافظه</div>
                                </div>
                            </div>
                            <div>
                                <Button
                                    text={"متوجه شدم"}
                                    className="w-[190px] !h-10 !border !border-primary-600"
                                    type={ButtonType.TERTIARY}
                                    textClassName="!text-primary-600"
                                    autoFocus={false}
                                    onClick={() => {
                                        setShowPlanWarningModal(false);
                                        sessionStorage.setItem("DANGER_PLAN_STATUS", String(true));
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </Dialog>
            )}
        </>
    );
}
